import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { GTM_ID } from 'core/constants/general.constants';
import { addressesSelector } from 'core/store/addresses/selectors';
import { updateJustLoggedIn } from 'core/store/auth';
import { authGetCustomerSelector, selectJustLoggedIn } from 'core/store/auth/selectors';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import { getAppInstanceIdItem } from 'core/utils/app-instance-id.utils';
import { triggerInitializeUserEvent, triggerLoginSuccessEvent } from 'shared/utils/gtm-events/login.events';
import { initializeInsider, insertInsiderScript, setInsiderUser } from 'shared/utils/insider.utils';
import { userObservability } from 'shared/utils/observability/user.observability';

const useInitializeEvents = () => {
  const customer = useAppSelector(authGetCustomerSelector);
  const { addresses } = useAppSelector(addressesSelector);
  const justLoggedIn = useAppSelector(selectJustLoggedIn);
  const dispatch = useAppDispatch();
  const customerId = customer?.id;
  const { description: priceListDescription } = customer?.priceList ?? {};

  useEffect(() => {
    const initializeGTM = () => {
      if (customer) {
        userObservability.setGlobalCustomerAttributes(customer);

        if (GTM_ID) {
          TagManager.initialize({
            gtmId: GTM_ID,
          });
          const appInstanceId = getAppInstanceIdItem();

          triggerInitializeUserEvent({
            documentType: customer.basicData.document.type,
            documentNumber: customer.basicData.document.number,
            priceList: customer.priceList.id,
            externalDistributorName: customer.distributorName,
            department: addresses[0]?.department ?? '',
            district: addresses[0]?.district ?? '',
            appInstanceId,
          });
        }
      }
    };

    initializeGTM();
  }, [priceListDescription, customer, addresses]);

  useEffect(() => {
    const initializeInsiderUser = async () => {
      if (customerId) {
        setInsiderUser(customer, customerId, addresses);
        await insertInsiderScript();
        initializeInsider();
      }
    };

    initializeInsiderUser();
  }, [customerId, customer, addresses]);

  useEffect(() => {
    if (customer && justLoggedIn) {
      triggerLoginSuccessEvent({
        document: customer.basicData.document.number,
        priceList: customer.priceList.id,
        externalDistributorName: customer.distributorName,
        docType: customer.basicData.document.type,
      });
      dispatch(updateJustLoggedIn(false));
    }
  }, [customer, dispatch, justLoggedIn]);
};

export default useInitializeEvents;
